'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidMonthString = getValidMonthString;
exports.getValidYearString = getValidYearString;
exports.getFullYear = getFullYear;
exports.getFormattedExpirationDate = getFormattedExpirationDate;
/**
 * Date Utilities
 *
 * Helps to solve problems when working with dates.
 * Makes it easier when validating, formatting, getting date values.
 *
 * Uses:
 * - getting a valid month
 * - expiration date parsing and formatting
 */

/**
 * Returns a valid month number 01-12
 *
 * @param {string} month
 * @return {string} month
 */
function getValidMonthString(month) {

  // get the int value of the month
  var monthInt = +month;

  // make sure the month is valid: 01-12
  if (!monthInt || monthInt < 1) {
    return '01';
  } else if (monthInt > 12) {
    return '12';
  }
  return month.toString();
}

/**
 * Return a valud year that's not less than the current year
 *
 * @example for a year value of '00', return the current year
 *
 * @param {string} year
 * @return {string} year
 */
function getValidYearString(year) {
  var currentYear = new Date().getFullYear().toString().slice(-2);
  if (year.length === 2) {
    return +year < currentYear ? currentYear : year;
  }
  return year.toString();
}

/**
 * Returns the full year 20** if year.length > 1
 * - prepends '20' to the last 2 digits
 * - just return the year value if year.length < 2
 *
 * @example for a year value of '88', return '2088'
 * @example for a year value of '2000', return the current year
 *
 * @param {string} year
 * @return {string} a valid full year
 */
function getFullYear(year) {
  if (year.length > 1) {
    return '20' + getValidYearString(year.slice(-2));
  }

  return year.toString();
}

/**
 * Returns a formatted expiration date
 *
 * - if the month is less than 10, we pad the month with a '0'
 * @example for a date value of '8', return '08'
 *
 * - the date is formatted with the '/' inserted
 * @example for a date value of '1216', return '12/16'
 *
 * @param {string} date
 * @return {string} expirationDate
 */
function getFormattedExpirationDate(date) {
  var expirationDate = date.replace(/\D+/g, '');

  if (expirationDate.length === 1 && expirationDate !== '0' && expirationDate !== '1') {

    // pad the month with a '0' only if the value is > 1
    // because the user could want to enter '11' or '12'
    expirationDate = '0' + date;
  } else if (expirationDate.length > 1) {
    var month = expirationDate.slice(0, 2);
    var year = getValidYearString(expirationDate.slice(2));

    // get a valid full year
    if (year.length > 3) {
      year = getFullYear(year);
    }

    // format the expiration date with the '/'
    expirationDate = getValidMonthString(month) + '/' + year;
  }

  return expirationDate;
}


//////////////////
// WEBPACK FOOTER
// /workspace/Release/~/react-expiry-date/dist/date-utils.js
// module id = 355
// module chunks = 6